import { writable } from 'svelte/store';
export const CONTACT_STORE = writable({});
export const CONTACT_HASH = writable('initial');
